import { Injectable } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { EntityService } from 'src/app/_core/entity.service';
import { DialogsService } from 'src/app/_services/dialogs.service';

import * as _ from 'lodash';
declare const $: any;

@Injectable({
	providedIn: 'root'
})
export class OrderItemsUtilsService {

	UIArgs: any = {
		//viewDefIcon: 'assets/images/meal.svg',
		//categoryDefIcon: 'assets/images/meal.svg',
		//itemDefIcon: 'assets/images/meal.svg',
		selectedMenu: null
	}
	constructor(
		public appService: AppService,
		public entityService: EntityService,
		public dialogsService: DialogsService,
	) {

	}

	// ------------------------------------------------------------------------------------------------->
	// catalog utilities
	// ------------------------------------------------------------------------------------------------->

	findCatalogOffer(_catalog, _offerId) {
		var ret;
		var arr = _catalog.view;
		for (var i = 0; i < arr.length; i++) {
			var ret = findRecursive(arr[i], _offerId);
			if (ret) {
				return ret;
			}
		}

		function findRecursive(o, _offerId) {
			if (o.offer && o.offer == _offerId) return o;
			if (o.items) {
				var _arr = o.items;
				for (var i = 0; i < _arr.length; i++) {
					var _ret = findRecursive(_arr[i], _offerId);
					if (_ret) return _ret;
				}
			}
		}
	}

	checkMenuItemActive(item, storage) {
		if (item.disabled) return false;
		if (item.orderTime && item.orderTime != 'sameDay') return false;
		if (item.schedule && !storage.activeTimeslots[item.schedule]) return false;
		if (item.services && item.services.length && item.services.indexOf(storage.orderMode) == -1) return false;
		return true;
	}

	prepareUpsaleGroup(group, storage) {
		let _catalog = storage.catalog;
		let that = this;
		if (group.disabled) {
			group.active = false;
			return group;
		}
		this.setCardDisplayProps(group, storage.cardOption.cardStyle);
		if (!group.description_display) group.description_display = storage.cardOption.description_display;
		if (!group.grid_size) group.grid_size = storage.folderOptions.grid_size;

		let offers = [];
		_.each(group.offers, _member => {
			if (_member.disabled) return;
			if (!_member._id) _member._id = this.getObjectId();
			_member.offer = _member.offerId;

			let viewOffer = this.findCatalogOffer(_catalog, _member.offerId);
			let member = _member;
			if (viewOffer) {
				member = _.cloneDeep(viewOffer);
				member._type = _member._type;
				delete member.upsaleGroup;
			}

			that.setCardDisplayProps(member, group.cardStyle);
			if (!member.description_display) member.description_display = group.description_display;
			that.prepareViewItem(_catalog, member, null);

			if (!member._disabled) {
				offers.push(member);
				member.realName = _member.realName || _member.name;
				if (_member.caption) member.name = this.getTranslation(storage, _member, 'caption');
				let memberImage = _.get(_member, 'customImage.url');
				if (memberImage) member.imageURL = memberImage;
				//else if (!member.imageURL) {
				//	member.iconImage = true;
				//	member.imageURL = that.UIArgs.viewDefIcon;
				//}
			}
		});
		//offers = offers.slice(0, 1)
		group.offers = offers;
		group.allOffers = offers;
		group._prepared = true;
		group.active = offers.length > 0;
		return group;
	}

	prepareOfferBundles(offer, storage) {
		var group = this.prepareUpsaleGroup(offer.offerBundle, storage);
		if (group.active) {
			let preSaleOffers = _.filter(group.offers, { _type: 'preSale' });
			let crossSaleOffers = _.filter(group.offers, { _type: 'crossSale' });
			delete group.offers;

			if (preSaleOffers.length) {
				offer.preSale = _.cloneDeep(group);
				offer.preSale.title = this.getTranslation(storage, offer.preSale, 'title', (group.requirePreSelection ? 'presale_required_title' : 'presale_title'));
				offer.preSale.description = this.getTranslation(storage, offer.preSale, 'description', null, true);
				offer.preSale.offers = preSaleOffers;
			}
			if (crossSaleOffers.length) {
				offer.crossSale = _.cloneDeep(group);
				offer.crossSale.containsOffer = _.find(crossSaleOffers, { offer: offer.offer }) != null;
				offer.crossSale.title = this.getTranslation(storage, offer.crossSale, 'crossTitle', (group.requireCrossSelection ? 'crosssale_required_title' : 'crosssale_title'));
				offer.crossSale.description = this.getTranslation(storage, offer.crossSale, 'crossDescription', null, true);
				_.each(crossSaleOffers, _offer => {
					_offer.diffPrice = _offer.price - offer.price;
				}),
					offer.crossSale.offers = crossSaleOffers;
			}
		}
		return group;
	}

	prepareItemsFolder(_catalog, folder, storage, isSubFolder?) {
		let that = this;
		let _locale = this.appService.locale;
		if (folder.member_display == 'card') delete folder.member_display;

		if (this.checkMenuItemActive(folder, storage)) {
			this.setCardDisplayProps(folder, storage.cardOption.cardStyle);
			if (!folder.description_display) folder.description_display = storage.cardOption.description_display;
			if (!folder.grid_size) folder.grid_size = storage.folderOptions.grid_size;
			if (!folder.enableQuickAdd) folder.enableQuickAdd = storage.folderOptions.enableQuickAdd;
			translateFolderMessage(folder);

			folder.items = _.filter(folder.items, (member) => {
				member.active = that.checkMenuItemActive(member, storage);

				if (!member.description_display) member.description_display = folder.description_display;
				if (!member.upsaleGroup) member.upsaleGroup = folder.upsaleGroup;

				if (member.active) {
					if (member.type == 'folder') {
						if (storage.isTranslated) {
							delete member.description;
							if (member.translations) {
								let trans = member.translations[_locale];
								if (trans) {
									_.each(trans, (val, key) => {
										if (key == 'name') {
											member.$$translated = true;
											member.realName = member[key];
										}
										member[key] = val;
									});
								}
							}
						}

						if (member.items && member.items.length) {
							//if (member.description_display == 'show' && member.message)
							member.description = member.message;

							if (_.isUndefined(member.enableQuickAdd)) member.enableQuickAdd = folder.enableQuickAdd;
							let subFolder = member; //_.cloneDeep(member);
							member.cardStyle = folder.cardStyle;
							that.setCatDisplayProps(member, member.cardStyle);

							that.setCardDisplayProps(subFolder, folder.cardStyle);

							if (!subFolder.description_display) subFolder.description_display = folder.description_display;
							if (!subFolder.grid_size) subFolder.grid_size = folder.grid_size;
							if (!subFolder.enableQuickAdd) subFolder.enableQuickAdd = folder.enableQuickAdd;
							that.prepareItemsFolder(_catalog, subFolder, storage, true);
							translateFolderMessage(member);
							if (subFolder.items.length) {
								member.parentId = folder._id;
								if (member.customImage) {
									member.imageURL = member.customImage.image;
									member._hasImage = true;
								} else if (member.icon) {
									member.imageURL = member.icon.url;
									member.iconImage = true;
								}
								storage.catalog.folders.push(subFolder);
								return true;
							}
						}
					} else {
						member.enableQuickAdd = folder.enableQuickAdd == 'yes';
						that.setCardDisplayProps(member, folder.cardStyle);
						that.prepareViewItem(_catalog, member, folder.icon);
						if (member._prepared) {
							if (!member.imageURL && folder.icon) {
								member.iconImage = true;
								member.imageURL = folder.icon.url;
							}
							if (!storage.catalog.tmpViewOffers[member.offer]) {
								storage.catalog.tmpViewOffers[member.offer] = member;
							}
							return true;
						}

					}
				}
			});
			return folder.items.length > 0;
		}
		return false;

		function translateFolderMessage(member) {
			if (storage.isTranslated && member.alert && member.alert.translations) {
				let _trans = member.alert.translations[_locale];
				if (_trans && _trans.message) {
					member.alert.message = _trans.message;
				}
			}
		}
	}
	folders

	setCardDisplayProps(member, _style: any = {}) {
		let style = _.assignIn({}, _style);
		if (member.cardBgImageColor) {
			style['background-color'] = member.cardBgImageColor;
		}
		if (member.cardBgImageSize) {
			let bgSize;
			switch (member.cardBgImageSize) {
				case "stretch": bgSize = "100% 100%"; break;
				case "padded-x": bgSize = "90% auto"; break;
				case "padded-y": bgSize = "auto 90%"; break;
				default: bgSize = member.cardBgImageSize;
			}
			style['background-size'] = bgSize;
		}
		if (member.cardImageHeight) {
			style['pxHeight'] = member.cardImageHeight;
			style['height'] = member.cardImageHeight + 'px';
		}
		member.cardStyle = style;
	}
	setCatDisplayProps(member, _style) {
		let style = _.assignIn({}, _style);
		if (member.catBgImageColor) {
			style['background-color'] = member.catBgImageColor;
		}
		if (member.catBgImageSize) {
			let bgSize;
			switch (member.catBgImageSize) {
				case "stretch": bgSize = "100% 100%"; break;
				case "padded-x": bgSize = "90% auto"; break;
				case "padded-y": bgSize = "auto 90%"; break;
				default: bgSize = member.catBgImageSize;
			}
			style['background-size'] = bgSize;
		}
		member.catStyle = style;
	}

	prepareViewItem(_catalog, item, defIcon?) {
		let that = this;
		if (item._proccesd) return;
		item._proccesd = true;
		item._enableEdit = true;
		let wasImage = false;
		let offerId = item.offerId || item.offer;
		if (!offerId) {
			item.name = "[missing offer]";
		} else {
			let offer: any = _.find(_catalog.offers, { "_id": offerId });
			let price: any = _.find(_catalog.prices, { "offer": offerId, menu: item.menu });
			if (offer && price) {
				item._prepared = true;

				if (item.customName) {
					item.name = _.get(item, `translations.${_catalog.catalogTrans}.customName`, item.customName);
				} else {
					item.name = offer.name;
				}

				item.realName = offer.realName || offer.name;


				item.description = item.customDescription || offer.description;
				item._offer = _.cloneDeep(offer);
				item.price = item.viewPrice = price.price / 100;

				if (item.customImage) {
					item.imageURL = item.customImage.image;
					item._hasImage = true;
				} else if (item.icon) {
					item.imageURL = item.icon.url;
					item.iconImage = true;
				}
				if (item._offer.threeDImage && this.appService.appConfig.threeDImagesAddress) {
					item.threeDImage = this.appService.appConfig.threeDImagesAddress && `${this.appService.appConfig.threeDImagesAddress}/${item._offer.threeDImage}`;
				}

				var offerItem = offer.items && offer.items[0];
				if (offerItem) {
					if (_catalog.inventory[offerItem]) {
						item._disabled = true;
						item.stockDisabled = true;
						if (_catalog.hideInventory) {
							item._prepared = false;
						}
					}
					var refItem: any = _.find(_catalog.items, { "_id": offerItem });
					if (refItem) {
						item._item = _.cloneDeep(refItem);
						if (item._item.attributes && item._item.attributes[0]) {
							let offerAttributes = [];
							let nutritionAttributes = [];
							item._item.attributes.forEach(o => {
								const match = _.find(_catalog.itemAttributes, oo => oo._id == o);
								if (match) {
									switch (match.type) {
										case 'nutrition':
											nutritionAttributes.push(match);
											break;
										case 'food':
											offerAttributes.push(match);
											break;
										case 'marketing':
											item.marketting = match;
											break;
									}
								}
							});
							if (offerAttributes.length) item.offerAttributes = offerAttributes;
							if (nutritionAttributes.length) item.nutritionAttributes = nutritionAttributes;
						}

						if (!item._hasImage && refItem.image?.url) {
							item.imageURL = refItem.image.url;
						} else {
							item.imageURL = _catalog.defaultOfferUrl;
						}

						if (refItem.quantityType == 'Weight') {
							if (!_catalog.weightParams) item._disabled = true;
							refItem.isWeight = item.isWeight = true;

							let defaultWeight = _.get(refItem, 'packageSize.units');
							if (defaultWeight && _catalog.weightParams) {

								if (_catalog.weightParams.checkMin) {
									defaultWeight = Math.max(defaultWeight, _catalog.weightParams.min);
								}

								let ratio = _catalog.weightParams.ratio;
								item.viewPrice = _.round(defaultWeight / ratio * item.price, 2);
								if (offer.treatWeightAsSimple) {
									item._enableEdit = false;
									item.uom = _catalog.weightParams.base;
									item.baseUnits = defaultWeight / ratio;
									item.treatWeightAsSimple = true;
								}
							}
						}
					}

					if (!item.description && refItem) item.description = refItem.description;
					if (offer.openPrice) {
						item.openPrice = true;
					} else if (!item.isWeight && !_.get(offer, "selectionGroups[0]")) {
						var sGroups = item._item.modifierGroups;
						if (!sGroups || !sGroups.length) item._enableEdit = false;
						else if (sGroups.length == 1 && that.isModifierGroupCompulsary(_catalog, sGroups[0])) item._enableEdit = false;
					}
				}

			} else {
				item.disabled = item._disabled = true;
				var errors = [];
				if (!offer) errors.push("missing offer");
				if (!price) errors.push("missing price");
				item.errors = errors;
				console.error("Proccess Item Error", errors.join(", "), item)
			}
		}
	}

	prepareSelectItem(_catalog, item, forceWizard?) {
		let that = this;
		if (item._proccesdAdd) return;
		if (item._item) {
			that.prepareItem(_catalog, item._item, item);
		}
		let wasPreSelection = false;

		_.filter(item._offer.selectionGroups, function (sGroup) {
			if (!sGroup.minSelectionCount) sGroup.minSelectionCount = 0;
			sGroup.validationMessage = that.prepareGroupValidationMessage(sGroup.minSelectionCount, sGroup.selectionCount);
			var itemGroup: any = _.find(_catalog.itemGroups, { "_id": sGroup.itemGroup });
			if (itemGroup && !itemGroup.disabled) {
				item._enableEdit = true;
				sGroup._prepared = true;
				sGroup._visible = !itemGroup.hideGroup;
				sGroup.collapsed = itemGroup.collapseGroup;
				sGroup.display = forceWizard ? 'wizard' : itemGroup.display;
				sGroup.name = itemGroup.name;
				sGroup.description = itemGroup.description;
				sGroup.showItemDescription = itemGroup.showItemDescription;
				sGroup.showMemberImages = itemGroup.showMemberImages;
				if (sGroup.showMemberImages) {
					if (!itemGroup.cardStyle) that.setCardDisplayProps(itemGroup);
					sGroup.cardStyle = itemGroup.cardStyle;
				}
				if (!itemGroup.memberSelection) {
					sGroup.memberSelection = sGroup.selectionCount == 1 ? 'single' : 'multi';
				} else if (sGroup.selectionCount == 1) {
					sGroup.memberSelection = 'single';
				} else {
					sGroup.memberSelection = itemGroup.memberSelection;
				}
				sGroup.memberDisplay = itemGroup.memberDisplay;
				sGroup.enableQuickItemFlow = itemGroup.enableQuickItemFlow;
				that.prepareItemGroup(_catalog, itemGroup);
				if (itemGroup._hidden) sGroup._visible = false;//no visible items
				sGroup.items = _.cloneDeep(itemGroup.items);

				// force selection of all items in group
				let sName = sGroup.realName ? sGroup.realName : sGroup.name;
				if (itemGroup.selectAllByDefault || (sName && sName.indexOf("*") == 0)) {
					wasPreSelection = true;
					that.addAllItemGroupItems(item, sGroup, _catalog);
					if (!sGroup._visible) return true;
					sGroup.$isReversed = true;
				}

				if (!sGroup._visible) return false;
				let itemGroupDisplay = forceWizard ? 'wizard' : itemGroup.display;
				// prepare wizards / upsales
				if (itemGroupDisplay) {
					sGroup._display = itemGroupDisplay;
					sGroup._type = "sg";
					switch (itemGroupDisplay) {
						case "wizard":
							if (!item.wizard) item.wizard = [];
							item.wizard.push(sGroup);
							break;
					}
				} else {
					sGroup._display = 'inline';
				}

				return true;
				//sGroup.selection = { count: 0, items: [], itemHash: {} };
			}
		});

		if (!forceWizard) item.wizard = this.getOfferGenericView(_catalog, item);
		if (wasPreSelection) this.prepareOfferSelectionGroups(item);
		item._proccesdAdd = true;
		//wizard
	}
	getOfferGenericView(_catalog, item) {
		let view = [];
		if (item._offer.view) {
			_.each(item._offer.view, group => {
				if (_catalog.catalogTrans) group.name = _.get(group.translations, `${_catalog.catalogTrans}.name`, group.name)

				let members = [];
				_.each(group.members, member => {
					let group;
					switch (member.entity) {
						case "modifierGroups":
							group = _.find(item._item.modifierGroups, { modifierGroup: member._id });
							if (group) {
								group.$$type = 'modGroup';
								if (group._visible) members.push(group);
							}
							break;
						case "itemGroups":
							group = _.find(item._offer.selectionGroups, { itemGroup: member._id });
							if (group) {
								group.$$type = 'selectGroup';
								if (group._visible) members.push(group);
							}
							break;
					}
				});
				if (members.length) view.push({ ...group, members: members });
			});
			return view;
		}

		let generalGroupMembers = [], decisions = [], modifiers = [], itemGroups = [];;
		_.each(item._item?.modifierGroups, modGroup => {
			modGroup.$$type = 'modGroup';
			if (modGroup._visible) {
				if (modGroup.singleSelection) decisions.push(modGroup);
				else modifiers.push(modGroup);
			}
		});
		_.each(item._offer.selectionGroups, selectGroup => {
			selectGroup.$$type = 'selectGroup';
			if (selectGroup._visible) {
				if (selectGroup.display == 'wizard') {
					view.push({
						name: selectGroup.name,
						members: [selectGroup]
					});
				} else {
					itemGroups.push(selectGroup)
				}
			}
		});
		if (item._offer.showItemGroupsFirstInTab) generalGroupMembers = [...itemGroups, ...decisions, ...modifiers];
		else generalGroupMembers = [...decisions, ...modifiers, ...itemGroups];

		if (generalGroupMembers.length) {
			const gGroup = { _id: 'general', name: this.appService.translate("offer_general_step"), members: generalGroupMembers }
			if (item._offer.showItemGroupsFirstInWizard) view.push(gGroup);
			else view.unshift(gGroup);
		}
		return view;

		/*
		_.each(meta.offer.$$groups, member => {
			const subjectTarget = meta.catalogExtras[member.entity][member._id] || {};
			if (isolateScope) _.set(isolateScope, `${member.entity}.${member._id}`, _.cloneDeep(subjectTarget));
			switch (member.entity) {
				case "modifierGroups":
					generalGroupMembers.push(member);
					break;
				case "itemGroups":
					if (subjectTarget.display == 'wizard') {
						view.push({ ...member, ...{ members: [member] } });
					} else {
						if (meta.offerExtend.showItemGroupsFirstInTab) generalGroupMembers.push(member);
						else generalGroupMembers.unshift(member);
					}
					break;
			}
		});
		if (generalGroupMembers.length) {
			const gGroup = { _id: 'general', name: $translate.instant("KIOSK._VIEW.general_caption"), members: generalGroupMembers }
			if (meta.offerExtend.showItemGroupsFirstInWizard) view.push(gGroup);
			else view.unshift(gGroup);
		}
		*/
		return view;
	}

	prepareItemGroup = function (_catalog, itemGroup) {
		if (itemGroup._proccesd) return;
		itemGroup.items = _.filter(itemGroup.items, function (item) { return !item.disabled });
		let wasItem = false;
		_.each(itemGroup.items, function (sgItem, index) {
			if (!_.isObject(sgItem)) {
				itemGroup.items[index] = sgItem = { _id: sgItem }
			}
			var refItem: any = _.find(_catalog.items, { "_id": sgItem._id });
			//refItem.description = `${refItem.name}, ${refItem.name}, ${refItem.name}`
			var args = { itemGroup: itemGroup._id, item: sgItem._id };
			var price: any = _.find(_catalog.prices, args);
			sgItem.price = (price && price.price) || 0;
			if (sgItem.price > 0) {
				sgItem.price = sgItem.price / 100;
			} else {
				//sgItem.price = 2; //remove
			}

			if (refItem) {
				sgItem.name = refItem.name;
				sgItem.disabled = false;
				if (_catalog.inventory[sgItem._id]) {
					if (_catalog.hideInventory) sgItem.disabled = true;
					sgItem.stockDisabled = true;
					sgItem._hasDisabled = true;
					sgItem._prepared = true;
				} else {
					sgItem._prepared = true;
					wasItem = true;
				};
				sgItem._item = _.cloneDeep(refItem);
				sgItem._item.total = sgItem.price;
				sgItem._item.itemGroup = args.itemGroup;
				if (refItem.image && refItem.image.url) {
					sgItem.imageURL = refItem.image.url;
				};
			}
		});
		if (!wasItem) itemGroup._hidden = true;
	}

	addAllItemGroupItems(viewItem, group, _catalog) {
		let that = this;
		group.$wasChecked = true;
		group.$isReversed = true;
		var maxCount = group.selectionCount || 100;
		var addedCount = 0;
		if (!viewItem.total) viewItem.total = viewItem.price;
		_.each(group.items, member => {
			if (member._prepared && !_catalog.inventory[member._id]) {
				if (member._item._hasRequiered) return;
				if (!member._item.summary) that.prepareItem(_catalog, member._item, viewItem);
				if (!member._item.total) member._item.total = 0
				if (_.isUndefined(member._item._total)) member._item._total = member._item.total;

				if (addedCount == maxCount) return;

				var oldTotal = member._item.oldTotal || 0;
				var newTotal = member._item.total || 0;

				viewItem.total -= oldTotal;
				viewItem.total += newTotal;
				member._item.oldTotal = newTotal;

				member.count = 1;
				member._selected = true;
				delete group._requiered;
				++addedCount;
			}
		});
	}

	prepareOfferSelectionGroups(viewItem) {
		var selectionSummary = [];
		let that = this;
		_.each(viewItem._offer.selectionGroups, function (sG) {
			var arr = [];
			_.each(sG.items, function (item) {
				if (item._selected) {
					//$scope.ES.prepareItemSummary(item._item);
					arr.push(item);
				};
			});
			if (arr.length) {
				selectionSummary.push({
					itemGroup: sG.itemGroup,
					_id: sG._id,
					name: sG.name,
					items: arr,
					_visible: sG._visible
				});
			}
		});
		viewItem.selectionSummary = selectionSummary;
	}

	// ------------------------------------------------------------------------------------------------->


	prepareItem(_catalog, item, offer) {
		if (item._proccesd) return;
		let that = this;

		var _total = 0;
		item._hasRequiered = false;
		var isSingleModGroup = item.modifierGroups && item.modifierGroups.length == 1;
		let defaultFormation = item.formation[0] || this.appService.translate('default_formation');
		_.each(item.modifierGroups, function (sGroup) {
			var mGroup: any = _.find(_catalog.modifierGroups, { "_id": sGroup.modifierGroup });
			if (mGroup) {
				sGroup._prepared = true;
				item._hasModifierGroups = true;

				sGroup.name = mGroup.name;
				sGroup.description = mGroup.description;
				sGroup._visible = !mGroup.hideGroup;
				sGroup.collapsed = mGroup.collapseGroup;
				sGroup.memberSelection = mGroup.memberSelection || 'single';
				sGroup.memberDisplay = mGroup.memberDisplay;
				sGroup.singleSelection = mGroup.singleSelection;
				sGroup.modifiers = _.cloneDeep(mGroup.modifiers);
				sGroup.showItemDescription = mGroup.showItemDescription;
				sGroup.modifiers = _.filter(sGroup.modifiers, (member) => {
					if (member.disabled || (member.item && _catalog.inventory[member.item])) return false;
					if (member.item) {
						member._item = _.find(_catalog.items, { "_id": member.item });
						if (member._item?.nameInModifier) {
							if (!member.realName) member.realName = member.name;
							member.name = member._item?.nameInModifier;
						}
					}
					return true;
				});

				sGroup._expanded = true;
				// currently hard coded set modifier behavior to checkbox
				sGroup.modifierBehavior = "checkbox";
				sGroup._hasSelected = false;
				sGroup._hasNotSelected = false;

				// ----------------------------------------------------->

				sGroup.showMemberImages = mGroup.showMemberImages;
				if (sGroup.showMemberImages) {
					if (!mGroup.cardStyle) that.setCardDisplayProps(mGroup);
					sGroup.cardStyle = mGroup.cardStyle;
				}

				// ----------------------------------------------------->
				var defaults = sGroup.defaults && sGroup.defaults[0];
				if (defaults) {
					if (sGroup.singleSelection) {
						var mod: any = _.find(sGroup.modifiers, { '_id': sGroup.defaults[0].modifier });
						if (mod) {
							mod._selected = true;
							mod._isDefault = true;
						} else {
							item._hasRequiered = true;
							sGroup._visible = true;
						}
					} else {
						_.each(sGroup.defaults, function (def) {
							var mod: any = _.find(sGroup.modifiers, { '_id': def.modifier });
							if (def.formationUnit == "") def.formationUnit = defaultFormation;
							if (mod) {
								mod.count = 1;
								mod.formationUnit = def.formationUnit;
								mod.defaultFormationUnit = def.formationUnit;
							}
						});
					}
				} else if (sGroup.singleSelection) {
					item._hasRequiered = true;
					sGroup._visible = true;
				};
				if (!sGroup.singleSelection) {
					var compulsaryOP = 0;
					_.each(sGroup.modifiers, function (mod) {
						if (!mod.compulsory) mod.compulsory = false;
						var args: any = { modifierGroup: mGroup._id, modifier: mod._id };
						if (offer.menu) args.menu = offer.menu;
						var price: any = _.find(_catalog.prices, args);
						if (price) mod.price = price.price / 100;
						else mod.price = 0;
						if (mod.formationUnit) {
							_total += mod.price;
							mod.$isDefault = true;
							if (!mod.compulsory) sGroup._hasSelected = true;
							else ++compulsaryOP;
						} else {
							mod.compulsory = false;
							mod.$isDefault = false;
							sGroup._hasNotSelected = true;
						};
					});
					sGroup.compulsaryOP = compulsaryOP;
					if (sGroup.min && sGroup.min > 0 && sGroup.min - compulsaryOP > 0) {
						item._hasRequiered = true;
						sGroup._visible = true;
					}
					if (that.isModifierGroupCompulsary(_catalog, null, mGroup)) {
						sGroup._visible = false;
						if (isSingleModGroup) item._enableEdit = false;
					};
				};
				if (sGroup._hasSelected && sGroup._hasNotSelected) {
					sGroup._hasBoth = true;
				}
			} else {
				sGroup.$active = false
			};
		});
		if (_.find(item.modifierGroups, { _visible: true })) {
			offer._enableEdit = true;
			item._enableEdit = true;
		}

		item._addPrice = _total;
	}

	isModifierGroupCompulsary(_catalog, sGroup, mGroup?) {
		if (!mGroup) mGroup = _.find(_catalog.modifierGroups, { "_id": sGroup.modifierGroup });
		if (mGroup && !mGroup.singleSelection) {
			for (var i = 0; i < mGroup.modifiers.length; i++) {
				if (!mGroup.modifiers[i].compulsory) return false;
			}
			return true;
		}
	}

	// ------------------------------------------------------------------------------------------------->
	// offer utilities
	// ------------------------------------------------------------------------------------------------->

	validateOffer(viewItem, ModifierOrSelectionGroups?) {
		let currentItem = viewItem._item;
		let valid = true;

		if (currentItem) valid = this.validateItem(currentItem, []);
		if (!valid) return false;

		_.each(viewItem._offer.selectionGroups, function (group) {
			var min = group.minSelectionCount;
			var selected: any = _.filter(group.items, { '_selected': true }).length;
			if (selected < min) {
				valid = false;
				return false;
			}
		});
		return valid;
	}


	validateItem(item, arrErrors, dontInfo?) {
		let that = this;
		var valid = true;
		var modGroup;

		_.each(item.modifierGroups, function (group) {
			if (group.singleSelection) {
				var mod = _.find(group.modifiers, { '_selected': true });
				if (!mod) {
					if (!modGroup) modGroup = group;
					valid = false;
					group._requiered = true;
					group.collapsed = false;
					arrErrors.push(that.appService.translate("GROUP_VALIDATION.GROUP_MOD_SELECT_SINGLE_ERROR", { group: group.name }));
					if (arrErrors.length == 1) {
						that.highlightElement(`mg_${group._id}`);
					}
				}
			} else {
				if (that.checkModGroupSelection(group)) {
					valid = false;
					group._requiered = true;
					group.collapsed = false;
					arrErrors.push(group.name + ": " + group._requieredMessage);
					if (arrErrors.length == 1) {
						that.highlightElement(`mg_${group._id}`);
					}
				}
			}
		});
		return valid;
	}

	checkModGroupSelection(group) {
		let that = this;
		var min = group.min;
		if (min || group.max) {
			var op = group.compulsaryOP || 0;
			group._requieredMessage = that.prepareGroupValidationMessage(min - op, group.max - op);
		}
		if (min && min > 0) {
			var count = 0;
			_.each(group.modifiers, function (elem) {
				if (elem.formationUnit != null) {
					count += elem.count;
					return true;
				}
			});
			if (count < min) {
				group._requiered = true;
				return true;
			}
		}
		delete group._requiered;
		delete group._requieredMessage;
		return false;
	}

	prepareGroupValidationMessage(min, max) {
		if (!min && !max) {
			return;
		} else if (min && !max) {//Choose at least X items
			var message = min == 1 ? "SELECT_ATLEAST_ONE" : "SELECT_ATLEAST_SOME";
		} else if (!min && max) {//Choose up to X items
			var message = max == 1 ? "SELECT_UPTO_ONE" : "SELECT_UPTO_SOME";
		} else if (min == 1 && max == 1) {//Choose 1 item
			var message = "SELECT_ONE"
		} else if (min == max) {//Choose X items
			var message = "SELECT_SOME";
		} else if (min == 1 && max > min) {//Choose at least 1 item
			var message = "SELECT_ATLEAST_ONE";
		} else if (min > 1 && max > min) {//Choose between X to Y items
			var message = "SELECT_BETWEEN";
		} else {
			return;
		}
		return this.appService.translate("GROUP_VALIDATION." + message, { min: min, max: max })
	}

	getItemGroupSelectionCount(group) {
		var selectionCount = 0;
		_.each(group.items, item => {
			if (item._selected) {
				if (!item.count) item.count = 1;
				selectionCount += item.count;
			}
		});
		return selectionCount;
	}

	//----------------------------------------------------------------------------------------->
	// offer summary utilities
	//----------------------------------------------------------------------------------------->


	prepareOfferSummary(offer, prepareItems = true) {
		let that = this;
		if (prepareItems) that.prepareItemSummary(offer._item);

		var selectionSummary = [];

		_.each(offer._offer.selectionGroups, function (sG) {
			var arr = [];
			_.each(sG.items, function (item) {
				if (item._selected) {
					that.prepareItemSummary(item._item);
					arr.push(item);
				};
			});
			if (arr.length) {
				selectionSummary.push({
					itemGroup: sG.itemGroup,
					_id: sG._id,
					name: sG.name,
					items: arr,
					_visible: sG._visible
				});
			}
		});
		offer.selectionSummary = selectionSummary;
	}

	prepareItemSummary(item, extendedSummary?) {
		if (!item) return;
		if (item.quantityType == 'Weight' && item.$summary) {
			item.summary = { text: item.$summary }
			return;
		}

		let that = this;
		if (!item) return;
		let _decisions = [], _with = [], _without = [];
		const stWithout = that.appService.translate("without");
		const isMultiFormation = _.get(item, 'formation[1]', null);
		const firstFormation = _.get(item, 'formation[0]', null);

		_.each(item.modifierGroups, function (group) {
			if (group.singleSelection) {
				const mod: any = _.find(group.modifiers, { '_selected': true });
				if (mod && !mod._isDefault) _decisions.push(group.name + ": " + mod.name);
			} else {
				_.each(group.modifiers, function (mod) {
					if (mod.formationUnit) {
						var modGroups = that.generateModifierGroupsSummary(mod);
						if (mod.formationUnit != mod.defaultFormationUnit || modGroups || mod.count > 1) {
							let modVal, modaName = mod.name;
							if (mod.count > 1) modaName = `${mod.count}*${modaName}`;
							if (isMultiFormation && mod.formationUnit != firstFormation) {
								modaName += ` (${mod.formationUnit})`;
							}
							if (mod.price) {
								modVal = `${modaName} (${that.appService.parseCurrency(mod.price)})`;
							} else {
								modVal = modaName;
							}
							if (modGroups) modVal += ` ${modGroups}`;
							_with.push(modVal);
						}
					} else if (mod.defaultFormationUnit) {
						_without.push(stWithout + " " + mod.name);
					}
				});
			}
		});
		const verbs = _decisions.concat(_with, _without);
		delete item.summary;
		if (verbs.length) {
			item.summary = { text: verbs.join(", ") }
			if (extendedSummary) item.summary.lines = verbs;
		}
	}

	generateModifierGroupsSummary(mod) {
		let res = [];
		if (mod.groups) {
			var modVerbs = [];
			_.each(mod.groups, function (group) {
				if (group.value && group.value != group._default) {
					modVerbs.push(group.valueName);
				}
			});
			if (modVerbs.length) {
				res.push(`[${modVerbs.join(",")}]`);
			}
		}
		const modItemSummary = _.get(mod._item, 'summary.text');
		if (modItemSummary) {
			res.push(`[${modItemSummary}]`);
		}
		if (res.length) return res.join(",");
	}

	prepareOfferSummary_ex(offer, showItemGroupsFirstInWizard = false, showItemGroupsFirstInTab = false) {
		let that = this;
		let itemSummary = [], selectionSummary = [], wizardSummary = [], wizard = offer.wizard || [];
		that.prepareItemSummary_ex(offer._item, itemSummary);


		_.each(offer._offer.selectionGroups, function (sG) {
			if (!sG._visible) return;
			let arr = [], _total = 0;
			_.each(sG.items, function (item) {
				if (item._selected) {
					that.prepareItemSummary(item._item);
					arr.push(item);
					_total += (item._item.total || 0) * (item.count || 1);
				};
			});
			if (arr.length) {
				let line = {
					name: sG.name,
					items: arr,
					total: _total
				}
				if (wizard.indexOf(sG) != -1) wizardSummary.push(line);
				else selectionSummary.push(line);
			}
		});
		let general = [];
		if (showItemGroupsFirstInTab) general = selectionSummary.concat(itemSummary);
		else general = itemSummary.concat(selectionSummary);

		if (showItemGroupsFirstInWizard) return wizardSummary.concat(general);
		else return general.concat(wizardSummary);
	}

	prepareItemSummary_ex(item, summary) {
		let that = this;
		if (!item) return;
		const stWithout = that.appService.translate("without");
		const isMultiFormation = _.get(item, 'formation[1]', null);
		const firstFormation = _.get(item, 'formation[0]', null);

		_.each(item.modifierGroups, function (group) {
			if (group.singleSelection) {
				const mod: any = _.find(group.modifiers, { '_selected': true });
				if (mod) {
					summary.unshift({ "name": group.name, text: mod.name });
				}

			} else {
				let _with = [], _without = [], _verbs = [], _total = 0, wasModGroups;
				_.each(group.modifiers, function (mod) {

					if (mod.formationUnit) {
						if (mod._id == '"62aed9978e267df64dca2bc2"') debugger;
						const modGroups = that.generateModifierGroupsSummary(mod);
						if (mod.formationUnit != mod.defaultFormationUnit || modGroups || mod.count > 1) {
							let modVal, modaName = mod.name;

							if (mod.count > 1) modaName = `${mod.count}*${modaName}`;
							else mod.count = 1;
							if (isMultiFormation && mod.formationUnit != firstFormation) {
								modaName += ` (${mod.formationUnit}')`;
							}
							if (mod.price) {
								_total += mod.price * mod.count;
								modVal = `${modaName} ${that.appService.parseCurrency(mod.price)}`;
							} else {
								modVal = modaName;
							}
							if (modGroups) {
								wasModGroups = true;
								modVal += ` ${modGroups}`;
							}
							_with.push(modVal);
						}
					} else if (mod.defaultFormationUnit) {
						_without.push(`${stWithout} ${mod.name}`);
					}
				});
				_verbs = _with.concat(_without);
				if (_verbs.length) summary.push({ "name": group.name, text: _verbs.join(wasModGroups ? "\n" : ", "), total: _total });
			}
		});
	}

	getOfferSummary(offer) {
		const groups = [];

		// Check if selectionSummary already exists and use it (like in the template)
		if (offer?.selectionSummary?.length) {
			offer.selectionSummary.forEach(group => {
				if (group._visible) {
					const items = [];
					let groupTotalPrice = 0;

					group.items.forEach(item => {
						// Build item text like in template
						let itemText = '';
						let without = false;

						// Check if it's a "without" item
						if (item.without) {
							itemText = `${this.appService ? this.appService.translate('WITHOUT') : 'WITHOUT'} ${item.name || 'missing'}`;
							without = true;
						} else {
							// Add count if > 1
							if (item.count > 1) {
								itemText += `${item.count}*`;
							}
							itemText += item.name || 'missing';

							// Add price if exists and not without
							const itemPrice = item?._item?.total || item?.price || 0;
							if (itemPrice > 0) {
								itemText += ` +${itemPrice}`;
								groupTotalPrice += itemPrice * (item.count || 1);
							}

							// Add summary if exists
							if (item?._item?.summary?.text) {
								itemText += ` (${item._item.summary.text})`;
							}
						}

						items.push({
							...item,
							displayText: itemText,
							without: without,
							price: item?._item?.total || item?.price || 0,
							count: item.count || 1
						});
					});

					if (items.length) {
						groups.push({
							_id: group._id,
							name: group.name,
							_visible: group._visible,
							items,
							groupPrice: groupTotalPrice,
							displayText: `${group.name}: ${items.map(item => item.displayText).join(', ')}`
						});
					}
				}
			});
		}

		// If no selectionSummary, fall back to processing modifier and selection groups
		if (!groups.length) {
			// 1) Modifier groups
			if (offer?._item?.modifierGroups?.length) {
				offer._item.modifierGroups.forEach(group => {
					const selection = { modifiers: [], decisions: [] };
					let groupTotalPrice = 0;

					(group.modifiers || []).forEach(mod => {
						const without = mod.$isDefault && mod.defaultFormationUnit && !mod.formationUnit;
						const hasDecisions = !!mod?._item?.summary;

						if ((mod._selected && (!mod.$isDefault || hasDecisions)) || without) {
							// Build display text like template
							let displayText = '';

							if (without) {
								displayText = `${this.appService ? this.appService.translate('WITHOUT') : 'WITHOUT'} ${mod.name}`;
							} else {
								if (mod.count > 1) {
									displayText += `${mod.count}*`;
								}
								displayText += mod.name;

								if (mod.price > 0) {
									displayText += ` +${mod.price}`;
									groupTotalPrice += mod.price * (mod.count || 1);
								}
							}

							const modWithDisplay = {
								...mod,
								displayText,
								without,
								price: mod.price || 0,
								count: mod.count || 1
							};

							if (!group.singleSelection) selection.modifiers.push(modWithDisplay);
							else selection.decisions.push(modWithDisplay);
						}
					});

					const items = [...selection.decisions, ...selection.modifiers];
					if (items.length) {
						groups.push({
							_id: group._id,
							name: group.name,
							_visible: group._visible,
							items,
							isModifier: true,
							groupPrice: groupTotalPrice,
							displayText: `${group.name}: ${items.map(item => item.displayText).join(', ')}`
						});
					}
				});
			}

			// 2) Selection groups - check both locations
			const selectionGroups = offer?.selectionGroups || offer?._offer?.selectionGroups;
			if (selectionGroups?.length) {
				selectionGroups.forEach(sg => {
					const items = [];
					let itemsCounter = 0;
					let limitException = !!sg.limitException;
					let groupTotalPrice = 0;

					(sg.items || []).forEach(it => {
						if (it._selected) {
							itemsCounter += it.count ?? 0;

							const hasException = false; //this.checkThirdLevelMinMaxException(it._item);
							if (!limitException && hasException) {
								limitException = true;
							}

							// Build display text
							let displayText = '';
							if (it.count > 1) {
								displayText += `${it.count}*`;
							}
							displayText += it.name;

							const itemPrice = it.price || it._item?.price || 0;
							if (itemPrice > 0) {
								displayText += ` +${itemPrice}`;
								groupTotalPrice += itemPrice * (it.count || 1);
							}

							if (it?._item?.summary?.text) {
								displayText += ` (${it._item.summary.text})`;
							}

							items.push({
								...it,
								displayText,
								without: false,
								price: itemPrice,
								count: it.count || 1
							});
						}
					});

					if (!limitException) {
						const max = sg.selectionCount ?? Number.POSITIVE_INFINITY;
						const min = sg.minSelectionCount ?? 0;
						limitException = itemsCounter > max || itemsCounter < min;
					}

					if (items.length) {
						groups.push({
							_id: sg._id,
							name: sg.name,
							_visible: sg._visible,
							items,
							limitException,
							groupPrice: groupTotalPrice,
							displayText: `${sg.name}: ${items.map(item => item.displayText).join(', ')}`
						});
					}
				});
			}
		}

		// Calculate total price for the entire offer
		const totalPrice = groups.reduce((total, group) => total + (group.groupPrice || 0), 0) + (offer.price || offer.viewPrice || 0);

		// Add weight summary if exists (like in template)
		let weightSummary = '';
		if (offer.isWeight && offer._item?.$summary) {
			weightSummary = `${this.appService ? this.appService.translate('_WEIGHT.item_weight') : 'Weight'}: ${offer._item.$summary}`;
		}

		// Add remarks if exists (like in template)
		let remarks = '';
		if (offer.offerRemrks || (offer.preSelection?.offers?.length && offer.preSelection?.offers[0].offerRemrks)) {
			remarks = offer.offerRemrks || offer.preSelection.offers[0].offerRemrks;
		}

		// Build the full text like in the UI template
		const summaryLines = [];

		// Add offer title and quantity at the top
		const quantityText = offer.quantity && offer.quantity > 1 ? offer.quantity : 1;
		summaryLines.push(`${quantityText} ${offer.name || 'missing'}`);

		// Add weight summary if exists
		if (weightSummary) {
			summaryLines.push(weightSummary);
		}

		// Add each group with its items
		groups.forEach(group => {
			group.items.forEach(item => {
				let itemLine = '';

				// Add count with * format (always show count, even if 1)
				itemLine = `${item.count || 1}`;
				if (item.count > 1) {
					itemLine += '*';
				}

				// Add item name
				itemLine += ` ${item.name || 'missing'}`;

				// Add price if exists and > 0 - fix double ₪ issue
				if (item.price > 0) {
					const totalItemPrice = item.price * (item.count || 1);
					const formattedPrice = `+${totalItemPrice}`;
					// Only add + if it's an additional cost
					if (totalItemPrice > 0 && !item.without) {
						itemLine += formattedPrice;
					}
				} else if (item.without) {
					// For "without" items, show the group name and what's being removed
					itemLine = `${group.name}: ${item.displayText}`;
				}

				// Add summary/modifications if exists
				if (item._item?.summary?.text && !item.without) {
					itemLine += ` (${item._item.summary.text})`;
				}

				summaryLines.push(itemLine.trim());
			});
		});

		// Add remarks at the end if exists
		if (remarks) {
			summaryLines.push(`${remarks}`);
		}

		// Add total price line - fix double ₪ issue
		const formattedTotal = `${totalPrice}`;
		summaryLines.push(formattedTotal);

		return {
			offerId: offer._id,
			offerName: offer.name,
			offerBasePrice: offer.price || offer.viewPrice || 0,
			totalPrice: totalPrice,
			quantity: offer.quantity || 1,
			groups,
			weightSummary,
			remarks,
			// Full text representation like in template
			fullText: summaryLines.length > 0 ? summaryLines.toString() : ''
		};
	}


	// ------------------------------------------------------------------------------->
	// messages
	// ------------------------------------------------------------------------------->

	popMessages(storage, placement, forceOnce?) {
		let messages = _.filter(storage.messages, { placement: placement, isNew: true });
		if (!messages.length) return Promise.resolve(null);
		return this.popMessage(storage, messages, 0, forceOnce)
	}
	popMessage(storage, messages, index, forceOnce?) {
		if (!storage.messages) return Promise.reject();
		let that = this;
		let message = messages[index];
		if (!message) return Promise.resolve(null);
		if (message.showOnce || forceOnce) message.isNew = false;
		switch (message.displayType) {
			case "image":
				let url = _.get(message, 'desktopImage.url');//, 'assets/images/card_swipe.svg'
				if (!url) return Promise.resolve(null);
				return this.appService.imageDialog(url).then(() => {
					return that.popMessage(storage, messages, index + 1, forceOnce);
				});
			default:
				return this.appService.alert({ content: message.message }).then(() => {
					return that.popMessage(storage, messages, index + 1, forceOnce);
				});
		}
	}
	popCatMessage(storage, menu) {
		let message = menu.alert;
		if (!message || !message.enabled || message.wasShown) return Promise.resolve();
		if (message.showOnlyOnce) message.wasShown = true;
		switch (message.displayType) {
			case "image":
				let url = _.get(message, 'desktopImage.url');
				if (!url) return Promise.resolve(null);
				this.appService.imageDialog(url);
				break;
			default:
				this.appService.alert({ content: message.message })
				break;
		}
		return Promise.resolve();
	}

	// ------------------------------------------------------------------------------->
	// ui utilities
	// ------------------------------------------------------------------------------->

	animateAddToBasket(_hid?, newTotal?, resolveImmidiatly?) {
		return new Promise((resolve, reject) => {
			if (resolveImmidiatly) resolve(null);
			$("#btnCheckout").addClass('sheen');
			//$("#btnCheckoutCounter").addClass('animated faster pulse');
			setTimeout(o => {
				//$("#btnCheckoutCounter").removeClass('animated faster pulse');
				$("#btnCheckout").removeClass('sheen');
				if (!resolveImmidiatly) resolve(null);
			}, 1100);
		});
	}

	animateAddToBasket_alt(_hid, newTotal?) {
		let that = this;
		return new Promise((resolve, reject) => {
			let from = $(_hid);
			if (!from[0]) {
				resolve(null);
				return;
			}
			var $h = from.clone().addClass('card-move-animation').appendTo("body");
			if (newTotal) {
				$h.find("._x-pay-button").html(that.appService.parseCurrency(newTotal));
			}

			var posFrom = from.offset();
			if (!posFrom) return;
			let _transform = `translateX(${posFrom.left + "px"}) translateY(${posFrom.top + "px"})`;
			$h.css({ transform: _transform, width: from.outerWidth() + 'px', height: from.outerHeight() + 'px' });
			var $ho = $("<div class='animation-overlay'></div>").appendTo("body");
			$ho.addClass('_start');

			var to = $('#btnCheckout');
			var posTo = to.offset();

			$h.on('transitionend webkitTransitionEnd oTransitionEnd', function () {
				if ($h.hasClass('_end')) {
					$h.remove();
					$ho.remove();
					resolve(null);
					$("#btnCheckoutCounter").addClass('animated fast pulse');
					setTimeout(o => {
						$("#btnCheckoutCounter").removeClass('animated fast pulse');
					}, 500)
				} else {
					$h.addClass('_end');
					let _transform2 = `translateX(${(that.appService.direction == 'rtl' ? 0 : posTo.left) + "px"}) translateY(${posTo.top + "px"}) scale(0.1) rotate(-259deg)`;
					$h.css({ transform: _transform2 });
					$ho.removeClass('_start');
				}

			});

			setTimeout(o => {
				//let xOffset = posFrom.left - posTo.left;
				//let yOffset = posFrom.top - posTo.top;
				$h.addClass('_start');
				$h.css({ transform: _transform + ' scale(0.9)' });
			}, 0);
		});
	}

	highlightElementTimeout;
	highlightElement(elementId) {
		const _el = document.getElementById(elementId);
		if (!_el) return;
		clearTimeout(this.highlightElementTimeout);
		_el.classList.add('_highlight');
		this.highlightElementTimeout =  setTimeout(() => {
			_el.classList.remove('_highlight');
		}, 2000);
		// @ts-ignore
		_el.scrollIntoViewIfNeeded({});
	}


	// ------------------------------------------------------------------------------------------------->
	// background-image
	// ------------------------------------------------------------------------------------------------->

	getCardStyle(cat) {
		return _.extend({}, { 'background-image': `url(${cat.imageURL})` })
	}

	// ------------------------------------------------------------------------------------------------->
	// general utilities
	// ------------------------------------------------------------------------------------------------->

	getTranslation = function (storage, source, att, _default?, forceTranslation?) {
		if (source[att]) _default = source[att];
		else if (_default) _default = this.appService.translate(_default);
		if (!storage.isTranslated) return _default;
		if (forceTranslation) _default = null;
		let locale = this.appService.locale;
		return this.appService.decodeString(_.get(source, `translations.${locale}.${att}`, _default));
	}

	getObjectId() {
		let timestamp = (new Date().getTime() / 1000 | 0).toString(16);
		return timestamp + 'xxxxxxxxxxxxxxxx'.replace(/[x]/g, () => {
			return (Math.random() * 16 | 0).toString(16);
		}).toLowerCase();
	}

	fixSpecialChars(str) {
		var regexSpecialChars = /[\uD83D\uFFFD\uFE0F\u203C\u3010\u3011\u300A\u166D\u200C\u202A\u202C\u2049\u20E3\u300B\u300C\u3030\u065F\u0099\u0F3A\u0F3B\uF610\uFFFC]/g;
		return str.replace(regexSpecialChars, "");
	}


}
